import { ContainerTurnoverDto } from '@storage/app/api'
import { MultipleIcon } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'

interface Props {
  occupancies?: ContainerTurnoverDto[]
}
export const MultipleStackingIcon = observer(({ occupancies }: Props) => {
  const occupancyCount = useMemo(() => {
    if (occupancies?.every(occ => occ.isFlatRack && occ.isEmpty)) return 1

    return occupancies?.length ?? 0
  }, [occupancies])

  return <MultipleIcon amount={occupancyCount} />
})
